import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Activity } from 'lucide-react';
export function Problem() {
  return <section className="py-20 px-4 bg-navy-800 relative border-t border-navy-700" data-id="element-167">
      <div className="max-w-4xl mx-auto" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-169">
          <AlertTriangle className="w-16 h-16 text-red-500 mx-auto mb-6" data-id="element-170" />
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-171">
            El sistema de salud tradicional te dice que{' '}
            <span className="text-red-400" data-id="element-172">"es parte del envejecimiento"</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-navy-900 p-8 md:p-10 rounded-2xl border border-red-900/30 shadow-lg relative overflow-hidden" data-id="element-173">
          <div className="absolute top-0 left-0 w-2 h-full bg-red-500" data-id="element-174"></div>
          <Activity className="w-12 h-12 text-red-500/20 absolute top-4 right-4" data-id="element-175" />

          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed font-medium" data-id="element-176">
            Pero la realidad es que tu páncreas está agotado de procesar los
            consejos nutricionales obsoletos de los años 90.
          </p>
          <p className="text-xl md:text-2xl text-white font-bold mt-6" data-id="element-177">
            Estás acumulando azúcar en lugar de quemar combustible.
          </p>
        </motion.div>
      </div>
    </section>;
}